module.exports = __webpack_public_path__ + "static/img/SketchPng530e7af984bf512769c0b381b42bd01ca7b01a6e9dc40ec77907938c5d3281d8.f257cf37.png";